import { render, staticRenderFns } from "./VideoControls.vue?vue&type=template&id=3f89209e&scoped=true&"
import script from "./VideoControls.vue?vue&type=script&lang=js&"
export * from "./VideoControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89209e",
  null
  
)

export default component.exports